import { useEffect, useState } from "react";
import { useDataContext } from "./datacontext";

// This is a generic hook to GET data from BR api
// end point is the type of enpoint - for example for team is is "t" - form the api documentation it is shown as &r=t
const useBRData = (endpoint, params, accessKey) => {
  const [data, setData] = useState({});
  const [ parameters, setParameters ] = useState("");
  
  let p = "";
  for (const [key, value] of Object.entries(params)) {
    if (value) {
      p += `${key}=${value}&`;
    }
  }
  if (p !== parameters) {
      setParameters(p);
  }

  useEffect(() => {
    if (!accessKey) {
      setData([]);
      return;
    }

    // This function is called to FETCH the data form BR
    const fetchData = () => {
      setData([]);
        if (typeof accessKey === "Object") {
            throw new Error("accessKey is an object");
        }
      if (parameters.length > 0) {
        const url = `https://thegamedeveloper.co.za/brexport/api.php?${accessKey}&r=${endpoint}&${parameters}json=1`;
        fetch(url)
          .then((response) => response.json())
          .then((data) => {
            // Sometimes, for unknown reason the BR response is still in text format
            if (typeof data === "string") {
              data = JSON.parse(data);
            }
            // Store the data in a state for use in context
            setData(data);
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      } else {
        setData([]);
      }
    };
    // As this is inside the use effect, it should only be called when we have all the parameters
    fetchData();
  }, [endpoint, parameters, accessKey]);


  return { data };
};

export default useBRData;
